<template>
  <main>
    <!-- <CaptionView msg="Welcome to Your Vue.js App"/> -->
    <nav-bar :theme="theme" />
    <router-view @theme="theme = $event" id="app" />

    <footer class="footer sand-background">
      <div class="content has-text-centered">
        <p>
          <strong>© {{ new Date().getFullYear() }} BeatCaps</strong>,
          Patent Pending, made with love by
          <a href="https://www.linkedin.com/company/communote">Communote</a>
        </p>
      </div>
    </footer>
  </main>
</template>
<script>
import NavBar from './components/NavBar.vue'

export default {
  name: 'App',
  components: {
    NavBar
  },
  data () {
    return {
      theme: 'light'
    }
  }
}
</script>

<style lang="scss">
@import "bulma/bulma.scss";

#app {
  font-family: 'Raleway', sans-serif;
  font-display: swap;
  /*
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  */
}
.sand-background {
  background:  linear-gradient( rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0.1) ),
                url(/img/chris-barbalis-135761-unsplash.jpg) center / cover;
}

</style>
